module.exports = __webpack_public_path__ + "static/bg-wedding-dff403c0160ab0515312e8712ef1e7ea.jpg";